module.exports = __webpack_public_path__ + "static/img/COEN-LIVINGSTONE.0164f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COEN-LIVINGSTONE.jpg
// module id = o8Eq
// module chunks = 0